import { SxProps } from "@mui/material";
import { useEffect, useState } from "react";
import { StatusPicker, TaskItemStatusChangedDialogContent, useDialog } from "src/components";
import { ClosedTaskItemStatuses, DEFAULT_TASK_ITEM_STATUS, TASK_ITEM_STATUSES, TaskItemStatus } from "src/constants";
import { useEditTaskItemStatus } from "src/http";

interface IProps {
  variant: "button" | "select";
  taskItemGuid: string;
  status: TaskItemStatus;
  teamSlug?: string;
  ownerUserGuids: string[];
  disabled?: boolean;
  sx?: SxProps;
}

const TaskItemStatusPicker = (props: IProps) => {
  const [selectedStatus, setSelectedStatus] = useState<TaskItemStatus>(props.status ?? DEFAULT_TASK_ITEM_STATUS);
  const { mutate: editTaskItemStatus } = useEditTaskItemStatus();
  const { showDialog, closeDialog } = useDialog();

  useEffect(() => {
    setSelectedStatus(props.status ?? DEFAULT_TASK_ITEM_STATUS);
  }, [props.status]);

  async function handleStatusChanged(newSelectedStatus: TaskItemStatus) {
    setSelectedStatus(newSelectedStatus);

    if (newSelectedStatus !== TaskItemStatus.Open) {
      showDialog({
        content: (
          <TaskItemStatusChangedDialogContent
            taskItemGuid={props.taskItemGuid}
            status={newSelectedStatus}
            onDone={closeDialog}
          />
        ),
      });
    }

    await editTaskItemStatus({
      taskItemGuid: props.taskItemGuid,
      statusId: newSelectedStatus,
      teamSlug: props.teamSlug,
      ownerUserGuids: props.ownerUserGuids,
    });
  }

  return (
    <StatusPicker
      variant={props.variant}
      disabled={props.disabled}
      value={selectedStatus}
      options={TASK_ITEM_STATUSES.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : 0))}
      groupBy={(option) => (ClosedTaskItemStatuses.includes(option.id) ? "Closed Statuses" : "Active Statuses")}
      onChange={handleStatusChanged}
      sx={{ ...props.sx }}
    />
  );
};

export { TaskItemStatusPicker };
